import React, { useEffect, useState } from "react";
import SecondaryButton from "../buttons/SecondaryButton.js";

import Modal1 from "../modals/Modal1.js";

import PDF from "../pdf/PDF.js";
import downloadFile from "../api/download/downloadFile.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import SmallSpinner from "../loading/SmallSpinner.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import { getDocDataById, getDocDataByRef } from "../models/DataFunctions.js";
import { generateKey } from "../portal/InvoiceSign.js";

const FactureSlotVisualisateur = ({ folder, orgData, slot_id, prefix }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);
  const [slotData, setSlotData] = useState(null);

  const handleLoadUrl = async () => {
    setLoadingFile(true);
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "facture", "", folder.id, prefix);
    let folderData = await getDocDataByRef(folder.ref);
    let slotData = await getDocDataById("rapport_slot", slot_id);
    setSlotData(slotData);
    let file = slotData?.facture_file;
    if (file) window.open(file.url, "_blank");
    setLoadingFile(false);
  };

  const handleFetchData = async () => {
    let slotData = await getDocDataById("rapport_slot", slot_id);
    setSlotData(slotData);
  };

  useEffect(() => {
    if (folder && slot_id) {
      handleFetchData();
    }
  }, [folder, slot_id]);

  const handleDownload = () => {
    downloadFile(
      slotData?.facture_file,
      "Facture_" + folder.nom.replace(/ /g, "_") + ".pdf"
    );
  };

  return (
    <div className="flex flex-col gap-2 h-full ">
      <SecondaryButton
        disabled={!slotData?.facture_file}
        onClick={() => {
          handleLoadUrl();
        }}
        className="w-fit h-fit gap-2"
      >
        Voir <SmallSpinner loading={loadingFile} />
      </SecondaryButton>{" "}
      <SecondaryButton
        disabled={!slotData?.facture_file}
        onClick={() => handleDownload()}
        className="w-fit h-fit"
      >
        Télécharger
      </SecondaryButton>{" "}
    </div>
  );
};

export default FactureSlotVisualisateur;
